"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var context_1 = require("../context");
var MissingProviderError = /** @class */ (function (_super) {
    __extends(MissingProviderError, _super);
    function MissingProviderError() {
        return _super.call(this, "You must establish a <StoreContextProvider> around any usages of the savant-connector") || this;
    }
    return MissingProviderError;
}(Error));
/**
 * Utility hook that throws an error if a developer uses any of the store functionality outside of a
 * StoreContextProvider
 */
var useStoreContext = function () {
    var result = React.useContext(context_1.StoreContext);
    if (!result.store) {
        throw new MissingProviderError();
    }
    return result;
};
exports.default = useStoreContext;
//# sourceMappingURL=useStoreContext.js.map